import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "selectionBar", "selectedCount"]

  connect() {
    // Load selections from sessionStorage
    this.loadSelections()

    // Restore checkbox states for currently visible slots
    this.restoreCheckboxStates()

    this.updateUI()
  }

  loadSelections() {
    const stored = sessionStorage.getItem('calendarSelectedSlots')
    if (stored) {
      try {
        const data = JSON.parse(stored)
        this.selectedSlots = new Map(Object.entries(data))
      } catch (e) {
        this.selectedSlots = new Map()
      }
    } else {
      this.selectedSlots = new Map()
    }
  }

  saveSelections() {
    const data = Object.fromEntries(this.selectedSlots)
    sessionStorage.setItem('calendarSelectedSlots', JSON.stringify(data))
  }

  restoreCheckboxStates() {
    this.checkboxTargets.forEach(checkbox => {
      const slotId = checkbox.dataset.slotId
      if (this.selectedSlots.has(slotId)) {
        checkbox.checked = true
      }
    })
  }

  toggleSlot(event) {
    const checkbox = event.currentTarget
    const slotId = checkbox.dataset.slotId
    const slotDate = checkbox.dataset.slotDate
    const shiftName = checkbox.dataset.shiftName
    const shiftTime = checkbox.dataset.shiftTime

    if (checkbox.checked) {
      this.selectedSlots.set(slotId, { slotId, slotDate, shiftName, shiftTime })
    } else {
      this.selectedSlots.delete(slotId)
    }

    this.saveSelections()
    this.updateUI()
  }

  clearSelection() {
    this.selectedSlots.clear()
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = false
    })
    sessionStorage.removeItem('calendarSelectedSlots')
    this.updateUI()
  }

  proceedToSwap() {
    if (this.selectedSlots.size === 0) return

    const slotIds = Array.from(this.selectedSlots.keys())
    const params = new URLSearchParams()
    slotIds.forEach(id => params.append('slot_ids[]', id))

    // Clear selections from sessionStorage when proceeding to swap
    sessionStorage.removeItem('calendarSelectedSlots')

    window.location.href = `/staff/multi_swaps/new?${params.toString()}`
  }

  updateUI() {
    const count = this.selectedSlots.size

    // Update count display
    if (this.hasSelectedCountTarget) {
      this.selectedCountTarget.textContent = count
    }

    // Show/hide selection bar
    if (this.hasSelectionBarTarget) {
      if (count > 0) {
        this.selectionBarTarget.classList.remove('hidden')
      } else {
        this.selectionBarTarget.classList.add('hidden')
      }
    }
  }
}
